import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const triggerWorkOrderRecalculation = async () => {
  const response = await axiosInstance.post(
    `${API_URL}/work-order-recalculation/recalculate-all`,
  );
  return response.data;
};
